module.exports = __webpack_public_path__ + "static/media/Uppink.86b8137c.svg";